<script setup lang="ts">
import type { State } from '@/store/store_types'
import { getNiceDuration } from '@/utils/timeUtils'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore<State>()

const locationData = computed(() => store.state.selectedFavLocation)

const niceDuration = (seconds: number): string => getNiceDuration(seconds)
</script>
<template>
  <v-container v-if="locationData" class="px-5 bg-pwt_snow">
    <v-card flat class="bg-pwt_snow">
      <v-card-title> {{ locationData.name }} </v-card-title>
      <v-card-text> {{ locationData.address }} </v-card-text>
      <!-- content -->
      <v-card-text>
        <v-card class="mb-5 pa-4" rounded="lg" color="pwt_snow">
          <ul style="list-style: none; padding-left: unset">
            <li class="text-h6">Location privacy settings</li>
            <li>visibility: {{ locationData.visibility }}</li>
            <li>location type: {{ locationData.type }}</li>
          </ul>
        </v-card>
        <v-card class="mb-5 pa-4" rounded="lg" color="pwt_snow">
          <ul
            v-if="locationData.planningData"
            style="list-style: none; padding-left: unset"
            class="pb-5"
          >
            <li class="text-h6">Trip Planning Defaults</li>
            <li v-if="locationData.planningData.loadWeightChange">
              load weight change: {{ locationData.planningData.loadWeightChange }} kg
            </li>
            <li
              v-if="
                locationData.planningData.chargeHere &&
                locationData.planningData.rating &&
                locationData.planningData.currentType
              "
            >
              Charge here with {{ locationData.planningData.rating }}kW
              {{ locationData.planningData.currentType }} charger
            </li>
            <li v-if="locationData.planningData.chargeHere">
              Normal state of charge after charging at this location:
              {{ locationData.planningData.SOCAfterCharging ?? 0 }}%
            </li>
            <li v-if="locationData.planningData.energyUsed">
              use {{ locationData.planningData.energyUsed }}kWh energy for idle processes at this
              location
            </li>
            <li v-if="locationData.planningData.stayDuration">
              Normal expected stay duration at this location:
              {{ niceDuration(locationData.planningData.stayDuration) }}
            </li>
          </ul>
          <template v-else>
            <v-card-title class="px-0">Trip Planning Defaults</v-card-title>
            <v-card-text class="px-0"> No trip planning defaults have been set for this location </v-card-text>
          </template>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
  <v-container v-else class="px-5 bg-pwt_snow">
    <v-card flat class="bg-pwt_snow">
      <v-card-title class="text-center"> Location not found </v-card-title>
      <v-card-text class="text-center"> The location you selected could not be found. </v-card-text>
    </v-card>
  </v-container>
</template>
